export enum routerMain {
    LOADING='/loading',
    HOME = '/trang-chu',
    USER = '/quan-ly-nguoi-dung',
    ROLE = '/quan-ly-vai-tro',
    CONFIG = '/cau-hinh-he-thong',
    CONFIG_DIGITAL_CERTIFICATE = '/cau-hinh-chung-thu-so',
    CATEGORY_SUBMISSION = '/trinh-ky-van-ban',
    CATEGORY_SUBMISSION_CONFIRM = '/phe-duyet-van-ban',
    CATEGORY_SUBMISSION_CONFIRMED = '/van-ban-da-phe-duyet',
    CATEGORY_SUBMISSION_REFUSE = '/van-ban-da-tu-choi',
    CATEGORY_DOCUMENT_INCOMING = '/tai-lieu-den',
    CATEGORY_DOCUMENT_SENT = '/tai-lieu-di',
    PERSONAL_DOCUMENT = '/tai-lieu-ca-nhan',
    CATEGORY_DOCUMENT_TYPE = '/loai-tai-lieu',
    CATEGORY_DOCUMENT = '/mau-tai-lieu',
    CATEGORY_TYPE_PROCEDURE = '/danh-muc-loai-quy-trinh',
    CATEGORY_PROCEDURE = '/quy-trinh',
    ORGANIZATION_TREE = '/quan-ly-so-do-to-chuc',
    EMAIL_TEMPLATE = '/mau-email',
    CATEGORY_POSITION = '/quan-ly-chuc-danh',
    PAGE_401='/401',
    PAGE_403 = '/403',
    PAGE_500 = '/500',
    PAGE_404 = '/404',
    SIGN_TEMPLATE = '/mau-chu-ky',
    CHANGE_PASS_WORD = '/doi-mat-khau',
    PROFILE = '/ho-so',
    CHANGE_ORGANIZATION = '/chuyen-doi-to-chuc',
    MAILING_HISTORY = '/lich-su-gui-mail',
    USER_MANUAL = `/huong-dan-su-dung`,
    CONFIG_STORAGE = '/cau-hinh-luu-tru-file',
    PARTNER = '/danh-muc-doi-tac',
    SIGN_NUMBER = '/ky-so',
    CHECK_SIGN = '/kiem-tra-chu-ky-so',
    SCREEN_SIGN = '/ky-so-ben-ngoai',
    SCREEN_SIGN_CONTRACT_DOC = '/ky-ho-so-ben-ngoai',
    SEARCH_SCREEN_SIGN = '/tim-ky-so-ben-ngoai',
    SEARCH_SCREEN_SIGN_CONTRACT_DOC = '/tim-ho-so-ben-ngoai',
    SCREEN_SIGN_SUBMISSION = '/ky-so-nhanh-ben-ngoai',
    SEARCH_SCREEN_SIGN_SUBMISSION = '/tim-ky-so-nhanh-ben-ngoai',
    SEARCH_SIGN_DOCUMENT = '/tim-tai-lieu-ben-ngoai',
    CLIENT_SIGN = '/tra-cuu-tai-lieu',
    LOGIN = '/login',
    CONTRACT = '/quan-ly-hop-dong',
    CONTRACT_DOCUMENT = '/quan-ly-ho-so-hop-dong',
    CONTRACT_CONFIRM = '/phe-duyet-hop-dong',
    CONTRACT_CONFIRMED = '/hop-dong-da-phe-duyet',
    CONTRACT_REFUSE = '/hop-dong-da-tu-choi',
    CONTRACT_DOCUMENT_CONFIRM = '/phe-duyet-ho-so-hop-dong',
    CATEGORY_CONTRACT_TYPE = '/danh-muc-loai-hop-dong',
    QUICK_WIZARD = '/khoi-tao-nhanh',
    CATEGORY_QUICK_SUBMISSION = '/trinh-ky-nhanh',
    NONE = '/',
    RESET_PASS = '/reset-password',
    SIGN_MULTIPLE='/ky-nhieu-tai-lieu',
    RELEASE_NOTE='/thong-bao-phat-hanh',
    CONTRACT_COMPLAINTS = '/khieu-nai-hop-dong',
    EMPTY="/empty",
    SYNTHESIS_REPORT="/bao-cao-tong-hop",
    AUTHORITY_MANAGER="/quan-ly-uy-quyen",
    CREATE_TICKET_SUPPORT="/gui-yeu-cau-ho-tro",
    APPROVAL_GROUP='/nhom-phe-duyet',
    SERVICE_MANAGER='/goi-dich-vu',

    IFRAME_MANAGEMENT_PACKAGE= '/iframe/quan-ly-goi-dich-vu',
    IFRAME_MANAGEMENT_PACKAGE_ADD= '/iframe/goi-san-pham',
    ADD_INFORMATION= '/bo-sung-thong-tin',

    REFERENCE_TEMPLATE_TEXT = '/mau-van-ban-tham-khao',
    REFERENCE_TEMPLATE_CONTRACT = '/mau-hop-dong-tham-khao',

    REQUEST_SUPPORT = '/yeu-cau-ho-tro',
    HPNY = '/chuc-mung-nam-moi',

}
